import { mkEntityIdCodec } from '@code-expert/mongo-ts/identity';
import type { eq } from '@code-expert/prelude';
import { iots, string } from '@code-expert/prelude';
import { SubmissionId, TaskId, UserId } from '/imports/domain/identity';
import { BlankId } from '/imports/modules/Quizzes/clozetext/domain/Blank';
import { QuestionId } from '/imports/modules/Quizzes/domain/Question';
import { QuizSnapshotId } from './QuizSnapshot';

//--------------------------------------------------------------------------------------------------

export const QuizAttemptIdBrand = Symbol('QuizAttemptId');
export const QuizAttemptId = mkEntityIdCodec(QuizAttemptIdBrand);
export type QuizAttemptId = iots.TypeOf<typeof QuizAttemptId>;
export const eqQuizAttemptId: eq.Eq<QuizAttemptId> = string.Eq;

//--------------------------------------------------------------------------------------------------

export const BlankValuesC = iots.record(QuestionId, iots.record(BlankId, iots.string));
export type BlankValues = iots.TypeOf<typeof BlankValuesC>;

export const QuizAttempt = iots.struct(
  {
    _id: QuizAttemptId,
    studentId: UserId,
    taskId: TaskId,
    snapshotId: QuizSnapshotId,
    createdAt: iots.date,
  },
  {
    blankValues: BlankValuesC,
    submissionId: SubmissionId,
  },
);

export type QuizAttempt = iots.TypeOf<typeof QuizAttempt>;
